import * as React from "react";
import {
    Toolbar,
    Button,
    ButtonGroup,
} from "@progress/kendo-react-buttons";
import {
    Form,
    Field,
    FormElement,
    FormRenderProps,
    FormSubmitClickEvent,
} from "@progress/kendo-react-form";
import { DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';

import { StackLayout, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../validators";

import { FormDatePicker, FormDropDownList, FormInput } from "../FormComponents";

import { useEditInventoryMutation } from '../../store/sunbright-api';
import ProductsSummary from "./ProductsSummary";


export interface InventoryNewProps {
    onReturn: any;
    regionID: number;
    regionName: string;
}

interface SelectedProduct {
    productid?: number;
    cdmvcode?: string;
    supplier?: string;
    description?: string;
    unitsperbox?: number;
}

const InventoryNew = ({
    onReturn,
    regionID,
    regionName
}: InventoryNewProps) => {

    const [editInventory, editResponse] = useEditInventoryMutation();

    const InventoryForm = React.useRef<any>(null);

    const [formHeight, setFormHeight] = React.useState<string>("250px");

    const [selectedProduct, setSelectedProduct] = React.useState<SelectedProduct>({});
    const [vaccineOnly, setVaccineOnly] = React.useState<boolean>(false);

    const submitForm = (event: FormSubmitClickEvent) => {

        const { isValid } = event;

        if (isValid) {
            const postInventory: any = InventoryForm.current.values;
            postInventory.uid = 0;
            postInventory.regionid = regionID;

            editInventory(postInventory)
                .unwrap()
                .then((payload) => { })
                .catch((error) => {
                    console.log(error)
                });
            onReturn();
        }
    }

    const handleProductSelected = (selectedProduct:any) => {

        setSelectedProduct({
            productid: selectedProduct.uid,
            cdmvcode: selectedProduct.cdmvcode,
            supplier: selectedProduct.supplier,
            description: selectedProduct.description,
            unitsperbox: selectedProduct.unitsperbox
        })
    }

    const handleVaccineCheck = (e: CheckboxChangeEvent) => {
        setVaccineOnly(e.value);
    }

    return (
        <React.Fragment>

            <div
                style={{ overflow: "auto", marginLeft: "16px" }}
                className={"sds-bold"}
            >
                <Form
                    ref={InventoryForm}
                    initialValues={selectedProduct }
                    key={JSON.stringify(selectedProduct) }
                    onSubmitClick={submitForm}
                    render={(formRenderProps: FormRenderProps) => (
                        <div>
                             <Toolbar>
                                    <Button
                                    icon="save"
                                        onClick={formRenderProps.onSubmit}
                                    >
                                        Save
                                    </Button>
                                <ButtonGroup>
                                    <Button
                                        icon="cancel"
                                        onClick={(e) => onReturn(false)}
                                    >
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </Toolbar>
                            <div style={{ alignSelf: "center" }}>
                                <FormElement
                                    style={{ height: formHeight, overflow: "auto", marginLeft: "16px", marginRight: "32px" }}>
                                    <div className={"sds-questionnaire"}>
                                        <fieldset
                                            style={{}}
                                            className={"k-form-fieldset"}
                                        >
                                            <legend
                                                style={{ paddingTop: "24px" }}
                                                className={"k-form-legend"}>
                                                {"Inventory Item - " + regionName}
                                            </legend>

                                            <GridLayout
                                                gap={{ rows: 0, cols: 0 }}
                                                cols={[{ width: "20%" }, { width: "20%" }, { width: "20%" }, { width: "20%" }, { width: "20%" }]}>
                                                <GridLayoutItem row={1} col={1} colSpan={1}>
                                                    <Field
                                                        label={"ProductID"}
                                                        name={"productid"}
                                                        component={FormInput}
                                                        validator={requiredValidator}
                                                    />
                                                </GridLayoutItem>
                                                <GridLayoutItem row={1} col={2} colSpan={1}>
                                                    <Field
                                                        label={"CDMV Code"}
                                                        name={"cdmvcode"}
                                                        component={FormInput}
                                                        disabled={true}
                                                    />
                                                </GridLayoutItem>
                                                <GridLayoutItem row={1} col={3} colSpan={1}>
                                                    <Field
                                                        label={"Supplier"}
                                                        name={"supplier"}
                                                        component={FormInput}
                                                        disabled={true}
                                                   />
                                                </GridLayoutItem>
                                                <GridLayoutItem row={1} col={4} colSpan={1}>
                                                    <Field
                                                        label={"Description"}
                                                        name={"description"}
                                                        component={FormInput}
                                                        disabled={true}
                                                       />
                                                </GridLayoutItem>
                                                <GridLayoutItem row={1} col={5} colSpan={1}>
                                                    <Field
                                                        label={"Units Per Box"}
                                                        name={"unitsperbox"}
                                                        component={FormInput}
                                                        disabled={true}
                                                    />
                                                </GridLayoutItem>
                                            </GridLayout>
                                            <StackLayout gap={16}>
                                                <Field
                                                    label={"Boxes"}
                                                    name={"boxes"}
                                                    component={FormInput}
                                                />
                                                <Field
                                                    label={"Units"}
                                                    name={"units"}
                                                    component={FormInput}
                                                />
                                                <Field
                                                    label={"Expiry"}
                                                    name={"expirytime"}
                                                    component={FormDatePicker}
                                                />
                                                <Field
                                                    label={"Min"}
                                                    name={"min"}
                                                    component={FormInput}
                                                />
                                                <Field
                                                    label={"Max"}
                                                    name={"max"}
                                                    component={FormInput}
                                                />
                                            </StackLayout>
                                        </fieldset>
                                    </div>
                                </FormElement>
                            </div>
                        </div>
                    )}
                />
                <div className={"k-form"} style={{paddingBottom: "16px"} }>
                    <StackLayout className={"sds-questionnaire k-form"} gap={16} >
                        <legend className={"k-form-legend"}>
                            Search
                        </legend>
                        <Checkbox
                            label={'Vaccines Only'}
                            labelPlacement={'after'}
                            defaultChecked={vaccineOnly}
                            onChange={handleVaccineCheck }
                        />
                        <div /><div /><div />
                    </StackLayout>
                </div>
                <div>
                    <ProductsSummary
                        onSelected={(product: any) => handleProductSelected(product)}
                        vaccineOnly={vaccineOnly}
                    />
                </div>

            </div>
        </React.Fragment>
    );
};
export default InventoryNew;
